import { Icon } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Card, Button, Title } from 'UI';
import styles from './WorkflowToggleDialog.module.scss';

type Props = {
  subAccountCount: number;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function ActivateWithSubAccountsDialog({ subAccountCount, onConfirm, onCancel }: Props) {
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const { t } = useTranslation('translations', {
    keyPrefix: 'TransactionApproval.Configuration.Workflows.ToggleDialog.Activate.WithSubAccounts',
  });

  return (
    <Card hoverEffect={false} className={styles.card}>
      <div className={styles.iconWrapper}>
        <Icon icon="cautionary2" size="xxlg" width="60px" height="60px" color="none" />
      </div>

      <Title level="4" className={styles.title}>
        {t('title', { defaultValue: 'Re-activate Workflow' })}
      </Title>

      <div className={styles.body}>
        <p className={styles.subtitle}>{t('subtitle', { defaultValue: 'Re-activating this workflow will:' })}</p>
        <ul className={styles.bullets}>
          <li>
            {t('bullet1', {
              count: subAccountCount,
              defaultValue: `Re-activate it on this account and the ${subAccountCount} sub-accounts where it was previously applied.`,
            })}
          </li>
          <li>
            {t('bullet2', {
              defaultValue: 'Restore the rails, tiers, and approvers exactly as they were saved.',
            })}
          </li>
          <li>{t('bullet3', { defaultValue: 'Automatically apply to any new sub-accounts you create.' })}</li>
        </ul>
      </div>

      <div className={styles.controls}>
        <Button colorScheme="secondary" size="small" onClick={onCancel}>
          {tGlobal('Buttons.cancel', { defaultValue: 'Cancel' })}
        </Button>
        <Button colorScheme="primary" size="small" onClick={onConfirm}>
          {t('confirmButton', { defaultValue: 'Re-activate Workflow' })}
        </Button>
      </div>
    </Card>
  );
}
